import React from "react";

const GrammarMobile = () => {
  return <div>Grammar Mobile</div>;
};
export default GrammarMobile;
